/* eslint-disable */
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'; 

export default {
    init() {
        // JavaScript to be fired on all pages

        // mobile menu

        var isMenuOpened;

        document.querySelector("#mobile-menu--trigger").addEventListener("click", openMobileMenu);
        document.querySelector("#mobile-menu--exit").addEventListener("click", closeMobileMenu);

        function openMobileMenu() {
            document.querySelector('.mobile-menu').classList.add('mobile-menu--active');
            window.isMenuOpened = true;
        }

        function closeMobileMenu() {
            document.querySelector('.mobile-menu').classList.remove('mobile-menu--active');
            window.isMenuOpened = false;
        }
        
        //swiper

        if ($('.image-slider__slider').length) {

        Swiper.use([Navigation, Pagination]);

        new Swiper('.image-slider__slider', {
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        }

        if ($('.hero-big').length) {

        Swiper.use([Navigation, Autoplay]);

            new Swiper('.hero-big__swiper', {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".hero-big__next",
                    prevEl: ".hero-big__prev",
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            })
        }

        if ($('.events-slider').length) {

        Swiper.use([Navigation]);

        let slidesPerView = 3.2;

        if($('.events-slider--smallcontainer').length) {
            slidesPerView = 2.4;
        }

            new Swiper('.events-slider__swiper', {
                slidesPerView: slidesPerView,
                spaceBetween: 70,
                navigation: {
                    nextEl: ".events-slider__next",
                    prevEl: ".events-slider__prev",
                },
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.4,
                        spaceBetween: 20,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2.4,
                        spaceBetween: 20,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: slidesPerView,
                        spaceBetween: 70,
                    }
                }
            })
        }

        if ($('.suppliers').length) {

        Swiper.use([Navigation]);

            new Swiper('.suppliers__swiper', {
                slidesPerView: 1.1,
                spaceBetween: 16,
                initialSlide: $('.suppliers__swiper .swiper-slide').length,
                navigation: {
                    nextEl: ".suppliers__next",
                    prevEl: ".suppliers__prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 50,
                    },
                },
            })
        }

        if ($('.menu-filter').length) {
            const triggers = document.querySelectorAll('.menu-filter__trigger')
            const menus = document.querySelectorAll('.menu__item')

            for (let i = 0; i < triggers.length; i++) {
                triggers[i].addEventListener('click', () => {
                    // Remove active classes
                    document.querySelector('.menu-filter__trigger--active').classList.remove('menu-filter__trigger--active')
                    document.querySelector('.menu-filter__menu--active').classList.remove('menu-filter__menu--active')

                    // add active classes
                    triggers[i].classList.add('menu-filter__trigger--active')
                    menus[i].classList.add('menu-filter__menu--active')
                })
                
            }
        }


        if ($('.past-events__swiper').length) {

        Swiper.use([Navigation]);

            new Swiper('.past-events__swiper', {
                slidesPerView: 1.15,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".past-events__next",
                    prevEl: ".past-events__prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.15,
                        spaceBetween: 70,
                    }
                },
            })
        }

        if ($('.coming-event').length) {
            const button = document.getElementById('join')
            const joinedButton = document.getElementById('joined')

            function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
            }

            function setButtonStatus() {
                if (getCookie('join_event')) {
                    button.classList.add('button--disabled')
                    joinedButton.classList.remove('button--disabled')
                }
            }

            setButtonStatus()

            button.addEventListener('click', () => {

                var form = $('#join_event');
                var postID = $('input[name="postID"]');

                $.ajax({
                    url: form.attr('action'),
                    data: {
                        action: "join_event",
                        postID: postID.val(),
                    }, // form data
                    type: form.attr('method'), // POST
                    success: function (data) {
                        document.cookie = "join_event=true";
                        setButtonStatus()
                    },
                });
                return false;
            });
        }

        if ($('.etage__swiper').length) {
            document.querySelectorAll('.etage__swiper').forEach(item => {
                new Swiper(item, {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 48,
                        }
                    }
                })
            })
        }

        //reserveren module

        $('.reservation--trigger').on('click', () => {
            $('.reservation-modal').addClass('reservation-modal--active');
        })
        $('.reservation-modal__bg, .close').on('click', () => {
            $('.reservation-modal').removeClass('reservation-modal--active');
        })

        const params = new URLSearchParams(window.location.search);

        // Check if we have the param
        if (params.has("popup")) {
            $('.reservation-modal').addClass('reservation-modal--active');
        }

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js